import { API } from '@/constant/constants'
import { DATA_PAGINATION } from '@/types'
import { OverlapDetailByFloor } from '@/types/siteOverlap'
import axiosClient from '../axiosClient'
import { SearchParams } from '@/types/common'
import { queryStringify } from '@/ultils'

export const floorOverlayApi = {
  getListByFloorId(floorId: number) {
    const url = API.CONFIG.FLOOR_OVERLAY.LIST_OF_FLOOR.replace(
      ':floorId',
      `${floorId}`,
    )
    return axiosClient.get<DATA_PAGINATION<OverlapDetailByFloor>>(url)
  },
  getListByInterfaceId(interfaceId: number, searchParams: SearchParams = {}) {
    const url = API.CONFIG.FLOOR_OVERLAY.LIST_OF_FLOOR_BY_INTERFACEID
    return axiosClient.get(
      url + queryStringify({ ...searchParams, interfaceId }),
    )
  },
}

export default floorOverlayApi
